module.exports = __webpack_public_path__ + "img/room2.bca2ddd9.jpeg";